import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { OvhNickhandleService } from '../../services/ovh-nickhandle.service';
import { OvhMonitService } from '../../services/ovh-monit.service';

@Component({
  selector: 'dns',
  templateUrl: './dns.component.html',
  styleUrls: ['./dns.component.css']
})
export class DnsComponent implements OnInit  {
  modalRef: BsModalRef;
  
  nickhandle : any;
  systems : any;
  selected : any;
  instanceDns : any;
  rows : any;
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  
  @Input() filter = 'ALL';
  
  constructor(
  	private readonly modalService: BsModalService,
  	private readonly router: Router,
  	private readonly route: ActivatedRoute,
  	private readonly nickhandleService: OvhNickhandleService,
  	private readonly monitService: OvhMonitService) {
  }
  
  ngOnInit() {
  	this.route.parent.paramMap.subscribe((params: ParamMap) => {
  		console.log(params	);
        const nickhandle = params.get('nickhandle');
        this.nickhandleService.getNickhandle(nickhandle).subscribe(
        	data => 
        		{ 
        			this.nickhandle = data;  
        		}
        	);
        this.monitService.getDnsStatus(nickhandle, this.filter).subscribe(
        	data =>
        		{
        			this.rows = this.systems = data;
        			this.loadingIndicator = false;
        		}
        );
      }
    );
   
  }
    
  updatedAtStatusClass({ row, column, value }): any {
    return {
        'bg-success': row.updatedAtStatus === 'OK',
        'bg-warning': row.updatedAtStatus === 'WARNING',
        'bg-danger': row.updatedAtStatus === 'DANGER',
    };
  }
  
   onSort($event) {
  }
  
  onSelect({ selected }) {
  	this.selected = selected[0];
  	this.instanceDns = null;
  	this.monitService.getInstanceDns(this.nickhandle.code, selected[0].projectId, selected[0].instanceId)
  		.subscribe(result => {
  			console.log(result);
  			this.instanceDns = result;
  		});
  }
  
  certificateExpirationStatusClass({ row, column, value }): any {
    return {
        'bg-success': row.certificateStatus === 'OK',
        'bg-warning': row.certificateStatus === 'WARNING' || row.certificateStatus === 'NONE',
        'bg-danger': row.certificateStatus === 'DANGER'
    };
  }
  
  pingStatusClass({ row, column, value }): any {
    return {
        'bg-success': row.pingStatus === 'OK',
        'bg-warning': row.pingStatus === 'WARNING',
        'bg-danger': row.pingStatus === 'DANGER'
    };
  }
  
}
